

import styled from 'styled-components';

import { colors, fonts } from '../shared/tokens';

export const CONTENT_WIDTH = 1060;
export const GUTTER = 80;

export const Section = styled.section`
  position: relative;
  width: 100%;
  background: ${({ $bg }) => $bg || colors.bg};
`;

export const Inner = styled.div`
  max-width: ${CONTENT_WIDTH}px;
  margin: 0 auto;
  padding: ${({ $py = 100 }) => $py}px ${GUTTER}px;

  @media (max-width: 768px) {
    padding: 64px 24px;
  }
`;


export const SectionHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 40px;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;

export const Heading2 = styled.h2`
  font-family: ${fonts.condensed};
  font-weight: 800;
  font-size: 44px;
  line-height: 52px;
  letter-spacing: -0.5px;
  text-transform: uppercase;
  color: ${colors.ink};

  em {
    font-style: normal;
    color: ${colors.cyan};
  }
`;

export const HeadDescription = styled.p`
  max-width: 360px;
  font-family: ${fonts.body};
  font-weight: 300;
  font-size: 15px;
  line-height: 25.5px;
  color: ${colors.muted};
`;


export const Kicker = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  border: 0.75px solid ${colors.redBorder};
  border-radius: 3px;
  font-family: ${fonts.condensed};
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: ${colors.red};
`;
